
export enum ActiveBuilderPane {
  CREATE_FORM,
  BUILD_LOGIC
}
